import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { supabase } from '../supabaseClient';
import PageEditor from '../features/editor/PageEditor';
import DatabasePage from '../features/database/DatabasePage';
import useRecents from '../features/nav/useRecents';

// 페이지 타입에 따라 분기: database → DB 뷰, db_row → 부모 DB 로 이동, 그 외 → 에디터
export default function PageRouter() {
  const { pageId } = useParams();
  const navigate = useNavigate();
  const { recordVisit } = useRecents();
  const [state, setState] = useState({ status: 'loading', type: null });

  useEffect(() => {
    let mounted = true;
    setState({ status: 'loading', type: null });
    supabase
      .schema('workspace')
      .from('pages')
      .select('type, database_id')
      .eq('id', pageId)
      .maybeSingle()
      .then(({ data, error }) => {
        if (!mounted) return;
        if (error || !data) { setState({ status: 'notfound', type: null }); return; }
        if (data.type === 'db_row' && data.database_id) {
          navigate(`/page/${data.database_id}`, { replace: true });
          return;
        }
        setState({ status: 'ready', type: data.type });
        // 방문 기록 — db_row 리다이렉트/notfound 제외, 실제 열람한 문서·DB만 기록.
        if (data.type === 'document') recordVisit(pageId);
      });
    return () => { mounted = false; };
  }, [pageId, navigate, recordVisit]);

  if (state.status === 'loading') {
    return <div className="center"><div className="spinner" /></div>;
  }
  if (state.status === 'notfound') {
    return (
      <div className="empty">
        <div className="big">🔍</div>
        <div style={{ fontSize: 16, color: 'var(--text)' }}>페이지를 찾을 수 없습니다.</div>
        <div className="muted">삭제되었거나 접근 권한이 없는 페이지일 수 있습니다.</div>
      </div>
    );
  }
  return state.type === 'database' ? <DatabasePage /> : <PageEditor />;
}
